import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Search, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, euro, dataIt, STATI, formatError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { toast } from "sonner";

const HEAD = ["N°", "Cliente", "Bici", "Ingresso", "Consegna prev.", "Stato", "Totale", ""];

export default function Schede() {
  const navigate = useNavigate();
  const [stato, setStato] = useState("tutti");
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/schede", { params: { stato: stato === "tutti" ? "" : stato, q } })
        .then((r) => setItems(r.data)).catch((e) => toast.error(formatError(e)));
    }, 250);
    return () => clearTimeout(t);
  }, [stato, q]);

  return (
    <div>
      <PageHeader overline="Officina" title="Schede di lavoro">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="schede-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="N°, cliente, bici..." className="w-56 bg-white pl-9" />
        </div>
        <Button data-testid="schede-new-button" onClick={() => navigate("/schede/nuova")} className="bg-orange-600 hover:bg-orange-700"><Plus className="mr-1 h-4 w-4" /> Nuova scheda</Button>
      </PageHeader>
      <Tabs value={stato} onValueChange={setStato} className="mb-4">
        <TabsList className="flex h-auto flex-wrap justify-start bg-white ring-1 ring-slate-200">
          <TabsTrigger value="tutti" data-testid="filter-status-tutti-tab">Tutte</TabsTrigger>
          {STATI.map((s) => <TabsTrigger key={s.value} value={s.value} data-testid={`filter-status-${s.value}-tab`}>{s.label}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
        <Table data-testid="schede-table">
          <TableHeader>
            <TableRow className="bg-slate-50 hover:bg-slate-50">
              {HEAD.map((h) => <TableHead key={h} className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((s) => (
              <TableRow key={s.id} className="cursor-pointer" onClick={() => navigate(`/schede/${s.id}`)} data-testid={`schede-row-${s.id}`}>
                <TableCell className="font-mono text-xs font-bold text-orange-600">#{s.numero}</TableCell>
                <TableCell className="font-semibold text-slate-900">{s.cliente_nome}</TableCell>
                <TableCell>{s.bici_desc}</TableCell>
                <TableCell>{dataIt(s.data_ingresso)}</TableCell>
                <TableCell>{dataIt(s.data_consegna_prevista)}</TableCell>
                <TableCell><StatusBadge stato={s.stato} /></TableCell>
                <TableCell className="font-mono font-bold">{euro(s.totale)}</TableCell>
                <TableCell onClick={(e) => e.stopPropagation()}>
                  <Button variant="ghost" size="icon" onClick={() => navigate(`/schede/${s.id}/stampa`)} data-testid={`schede-print-${s.id}`} title="Stampa"><Printer className="h-4 w-4" /></Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={8} className="py-16 text-center text-sm text-slate-500" data-testid="schede-empty">Nessuna scheda trovata.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
